<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openAccountDialog(true)"
      >新增账号</el-button
    >

    <el-table :data="list" border size="small" style="width: 1031px">
      <el-table-column
        prop="username"
        label="用户名"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column prop="role" label="角色" align="center" width="150">
        <template slot-scope="scope">
          {{ scope.row.role }}
        </template>
      </el-table-column>

      <el-table-column
        prop="isReceiveCorpNotifications"
        label="参与敏感业务操作的投票"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.isReceiveCorpNotifications"
            style="color: green"
          >
            是</span
          >
          <span v-else style="color: red"> 否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isAuditedWithOperation"
        label="敏感业务操作需要经过投票"
        align="center"
        width="170"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.isAuditedWithOperation" style="color: green">
            是</span
          >
          <span v-else style="color: red"> 否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="通知地址"
        align="center"
        width="200"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.address.length > 0">
            {{ scope.row.addressType }}://{{ scope.row.address }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.username != 'admin'" style="display: flex; flex-direction: row; justify-content: center; gap: 10px;">
            <span
              class="link-button"
              style="color: red"
              @click="removeAccount(scope.row)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openAccountDialog(false, scope.row)"
              >编辑</span
            >
            <span class="link-button" @click="resetAccountPassword(scope.row)"
              >重置密码</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑对话框 -->
    <AccountDialog
      v-if="shouldAccountDialogVisible"
      @close="onAccountDialogClosed()"
      :value="valueForAccountDialog"
    >
    </AccountDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import AccountDialog from "./AccountDialog";

export default {
  data() {
    return {
      shouldAccountDialogVisible: false, // 编辑对话框是否应该显示出来
      valueForAccountDialog: null, // 要传递给编辑对话框的数据
      list: [], // 列表里展示的数据
    };
  },

  async created() {
    // 拉取集合
    this.loadList();
  },

  components: {
    AccountDialog,
  },

  methods: {
    /**
     * 查询集合
     */
    async loadList() {
      this.list = await bizutil.loadAccounts();
    },

    /**
     * 删除
     * @param {*} id
     * @param {*} entry
     */
    async removeAccount(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除用户：“${entry.username}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/adminAccountRemove`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id == entry.id) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    /**
     * 重置密码
     * @param {*} entry
     */
    async resetAccountPassword(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认重置用户“${entry.username}”的密码？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/adminAccountResetPassword`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "重置成功",
          type: "success",
        });

        // 弹确认框
        await this.$confirm(
          `用户“${entry.username}”的新密码: ${resData.data.newPassword}`,
          { showCancelButton: false, confirmButtonText: "复制链接" }
        ).then(() => {
          try {
            let txt =
              `${this.$bizutil.getProjectName()}后台：` +
              `\n` +
              `- 地址：${this.$util.getBackendApiBase()}/admin/` +
              `\n` +
              `- 账号：${entry.username}` +
              `\n` +
              `- 密码：${resData.data.newPassword}` +
              `\n` +
              `（登录后可在右上角修改密码）`;

            navigator.clipboard.writeText(txt);
            this.$message({
              message: "复制成功",
              type: "success",
            });
          } catch (err) {
            this.$message.error("复制失败： " + JSON.stringify(err));
          }
        });
      } catch (e) {}
    },

    /**
     * 打开编辑对话框
     */
    async openAccountDialog(isCreate, oldData) {
      this.shouldAccountDialogVisible = true;
      this.valueForAccountDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * 编辑对话框关闭了
     */
    async onAccountDialogClosed() {
      this.shouldAccountDialogVisible = false;

      // 重新拉取集合
      return this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}

.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
::v-deep .el-table__row td {
  padding: 3px 0;
}

::v-deep .el-table .cell {
  line-height: 18px;
}
::v-deep .el-table .warning-row {
  background: #e7e7e7;
}

.link-button {
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>